exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.teach_modes__container--2Ku27 {\n\tmin-width: 410px;\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\tmargin-top: 15px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "teach_modes__container--2Ku27"
};